interface DataTableProps {
  title?: string;
  headers?: string[];
  rows?: string[][];
  striped?: boolean;
  bordered?: boolean;
}

export function DataTableBlock({ props }: { props: DataTableProps }) {
  const headers = props.headers ?? [];
  const rows = props.rows ?? [];
  if (headers.length === 0 && rows.length === 0) return null;

  return (
    <div className="overflow-x-auto">
      {props.title && <h3 className="text-lg font-semibold text-zinc-900 mb-3">{props.title}</h3>}
      <table className={`w-full text-sm text-left ${props.bordered ? 'border border-zinc-200' : ''}`}>
        {headers.length > 0 && (
          <thead>
            <tr className="bg-zinc-100 border-b border-zinc-200">
              {headers.map((h, i) => (
                <th key={i} className="px-4 py-2.5 font-semibold text-zinc-700">{h}</th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {rows.map((row, ri) => (
            <tr
              key={ri}
              className={`border-b border-zinc-100 ${props.striped && ri % 2 === 1 ? 'bg-zinc-50' : ''}`}
            >
              {row.map((cell, ci) => (
                <td key={ci} className="px-4 py-2 text-zinc-600">{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
